import { BillingPanel } from '../../../components/BillingPanel';

export function BillingTab() {
  return (
    <div className="max-w-2xl">
      <BillingPanel />
    </div>
  );
}
